import styles from './Cirkel.module.css';
import classNames from 'classnames';
import { BiCircle } from 'react-icons/bi';

interface CirkelProps {
  isActive: boolean;
}

const Cirkel = (props: CirkelProps) => {
  return (
    <div
      className={classNames(
        styles.cirkelContainer,
        props.isActive ? styles.aktivCirkel : ''
      )}
    >
      <BiCircle size="25" />
    </div>
  );
};

export default Cirkel;
